// Helper function to extract ID from path
export const extractIdFromPath = (path: string | undefined, defaultValue = '0'): string => {
    return path?.split('/').pop() ?? defaultValue;
};